import { createActionTypeModel } from "../../../store/global/action-model";


export * from "./bookings/types";
export * from "./artists/types";
export * from "./promoters/types";
export * from "./reports/types";
export * from "./venues/types";
export * from "./plugins/types";


export * from './bookings/types';
export * from './artists/types';
export * from './promoters/types';
export * from './reports/types';
export * from './venues/types';
export * from './tours/types';
export * from './templates/types'

// export const GET_BOOKING = 'GET_BOOKING';
// export const GET_BOOKING_LIST = 'GET_BOOKING_LIST';
// export const FETCH_BOOKING = 'FETCH_BOOKING';
// export const FETCH_BOOKING_LIST = 'FETCH_BOOKING_LIST';
// export const SET_BOOKING = 'SET_BOOKING';
// export const SET_BOOKING_LIST = 'SET_BOOKING_LIST';
// export const INSERT_BOOKING = 'INSERT_BOOKING';
// export const INSERT_BOOKING_LIST = 'INSERT_BOOKING_LIST';
// export const UPDATE_BOOKING = 'UPDATE_BOOKING';
// export const UPDATE_BOOKING_LIST = 'UPDATE_BOOKING_LIST';
// export const DELETE_BOOKING = 'DELETE_BOOKING';
// export const DELETE_BOOKING_LIST = 'DELETE_BOOKING_LIST';

// // SELECTED_BOOKING Action Types

// export const GET_SELECTED_BOOKING = 'GET_SELECTED_BOOKING';
// export const FETCH_SELECTED_BOOKING = 'FETCH_SELECTED_BOOKING';
// export const SET_SELECTED_BOOKING = 'SET_SELECTED_BOOKING';
// export const SET_SELECTED_BOOKING_AUTONOMOUSE = 'SET_SELECTED_BOOKING_AUTONOMOUSE';
// export const INSERT_SELECTED_BOOKING = 'INSERT_SELECTED_BOOKING';
// export const UPDATE_SELECTED_BOOKING = 'UPDATE_SELECTED_BOOKING';
// export const DELETE_SELECTED_BOOKING = 'DELETE_SELECTED_BOOKING';

// // BOOKING_DETAILS_FLAG Action Types

// export const SET_BOOKING_DETAILS_FLAG = 'SET_BOOKING_DETAILS_FLAG';
// export const TOGGLE_BOOKING_DETAILS_FLAG = 'SET_BOOKING_DETAILS_FLAG';
// export const OPEN_BOOKING_DETAILS = 'OPEN_BOOKING_DETAILS';
// export const CLOSE_BOOKING_DETAILS = 'CLOSE_BOOKING_DETAILS';

// // BOOKING_ARTIST Action Types

// export const GET_BOOKING_ARTIST = 'GET_BOOKING_ARTIST';
// export const GET_BOOKING_ARTIST_LIST = 'GET_BOOKING_ARTIST_LIST';
// export const FETCH_BOOKING_ARTIST = 'FETCH_BOOKING_ARTIST';
// export const FETCH_BOOKING_ARTIST_LIST = 'FETCH_BOOKING_ARTIST_LIST';
// export const SET_BOOKING_ARTIST = 'SET_BOOKING_ARTIST';
// export const SET_BOOKING_ARTIST_LIST = 'SET_BOOKING_ARTIST_LIST';
// export const INSERT_BOOKING_ARTIST = 'INSERT_BOOKING_ARTIST';
// export const INSERT_BOOKING_ARTIST_LIST = 'INSERT_BOOKING_ARTIST_LIST';
// export const UPDATE_BOOKING_ARTIST = 'UPDATE_BOOKING_ARTIST';
// export const UPDATE_BOOKING_ARTIST_LIST = 'UPDATE_BOOKING_ARTIST_LIST';
// export const DELETE_BOOKING_ARTIST = 'DELETE_BOOKING_ARTIST';
// export const DELETE_BOOKING_ARTIST_LIST = 'DELETE_BOOKING_ARTIST_LIST';
// export const LOAD_BOOKING_ARTIST = 'LOAD_BOOKING_ARTIST';




// // BOOKING_OVERVIEW Action Types

// export const GET_BOOKING_OVERVIEW = 'GET_BOOKING_OVERVIEW';
// export const FETCH_BOOKING_OVERVIEW = 'FETCH_BOOKING_OVERVIEW';
// export const SET_BOOKING_OVERVIEW = 'SET_BOOKING_OVERVIEW';
// export const INSERT_BOOKING_OVERVIEW = 'INSERT_BOOKING_OVERVIEW';
// export const UPDATE_BOOKING_OVERVIEW = 'UPDATE_BOOKING_OVERVIEW';
// export const DELETE_BOOKING_OVERVIEW = 'DELETE_BOOKING_OVERVIEW';

// // CUSTOM_CHECKLIST Action Types

// export const GET_CUSTOM_CHECKLIST = 'GET_CUSTOM_CHECKLIST';
// export const FETCH_CUSTOM_CHECKLIST = 'FETCH_CUSTOM_CHECKLIST';
// export const SET_CUSTOM_CHECKLIST = 'SET_CUSTOM_CHECKLIST';
// export const INSERT_CUSTOM_CHECKLIST = 'INSERT_CUSTOM_CHECKLIST';
// export const UPDATE_CUSTOM_CHECKLIST = 'UPDATE_CUSTOM_CHECKLIST';
// export const DELETE_CUSTOM_CHECKLIST = 'DELETE_CUSTOM_CHECKLIST';




// export const SELECT_BOX = 'SELECT_BOX';
// export const MINIMIZE_BOX = 'MINIMIZE_BOX';
// export const MAXIMIZE_BOX = 'MAXIMIZE_BOX';
// export const PIN_BOX = 'PIN_BOX';



// // BOOKING_NOTES Action Types

// export const GET_BOOKING_NOTES = 'GET_BOOKING_NOTES';
// export const FETCH_BOOKING_NOTES = 'FETCH_BOOKING_NOTES';
// export const SET_BOOKING_NOTES = 'SET_BOOKING_NOTES';
// export const INSERT_BOOKING_NOTES = 'INSERT_BOOKING_NOTES';
// export const UPDATE_BOOKING_NOTES = 'UPDATE_BOOKING_NOTES';
// export const DELETE_BOOKING_NOTES = 'DELETE_BOOKING_NOTES';


// export const CHECK_CHECKLIST_ITEM = 'CHECK_CHECKLIST_ITEM';
// export const UNCHECK_CHECKLIST_ITEM = 'UNCHECK_CHECKLIST_ITEM';
// export const TOGGLE_CHECKLIST_ITEM = 'TOGGLE_CHECKLIST_ITEM';
// export const SET_CHECKLIST_ITEM = 'SET_CHECKLIST_ITEM';
// export const SET_CHECKLIST_ITEM_VALUE = 'SET_CHECKLIST_ITEM_VALUE';
// export const SET_CHECKLIST_ITEM_DATASTATE = 'SET_LOADING_CHECKLIST_ITEM';


// export const CUSTOM_CHECKLIST_ITEM = createActionTypeModel('CustomChecklistItem');

// export const CHECK_CUSTOM_CHECKLIST_ITEM = 'CHECK_CUSTOM_CHECKLIST_ITEM';
// export const UNCHECK_CUSTOM_CHECKLIST_ITEM = 'UNCHECK_CUSTOM_CHECKLIST_ITEM';
// export const TOGGLE_CUSTOM_CHECKLIST_ITEM = 'TOGGLE_CUSTOM_CHECKLIST_ITEM';
// export const SET_CUSTOM_CHECKLIST_ITEM = 'SET_CUSTOM_CHECKLIST_ITEM';
// export const SET_CUSTOM_CHECKLIST_ITEM_VALUE = 'SET_CUSTOM_CHECKLIST_ITEM_VALUE';
// export const SET_CUSTOM_CHECKLIST_ITEM_DATASTATE = 'SET_CUSTOM_CHECKLIST_ITEM_DATASTATE';


// // BOOKING_OFFER_NOTES Action Types

// export const GET_BOOKING_OFFER_NOTES = 'GET_BOOKING_OFFER_NOTES';
// export const FETCH_BOOKING_OFFER_NOTES = 'FETCH_BOOKING_OFFER_NOTES';
// export const SET_BOOKING_OFFER_NOTES = 'SET_BOOKING_OFFER_NOTES';
// export const SET_BOOKING_OFFER_NOTES_DATASTATE = 'SET_BOOKING_OFFER_NOTES_DATASTATE';
// export const INSERT_BOOKING_OFFER_NOTES = 'INSERT_BOOKING_OFFER_NOTES';
// export const UPDATE_BOOKING_OFFER_NOTES = 'UPDATE_BOOKING_OFFER_NOTES';
// export const DELETE_BOOKING_OFFER_NOTES = 'DELETE_BOOKING_OFFER_NOTES';



// // BOOKING_ARTISTS_STATUS Action Types

// export const GET_BOOKING_ARTISTS_STATUS = 'GET_BOOKING_ARTISTS_STATUS';
// export const FETCH_BOOKING_ARTISTS_STATUS = 'FETCH_BOOKING_ARTISTS_STATUS';
// export const SET_BOOKING_ARTISTS_STATUS = 'SET_BOOKING_ARTISTS_STATUS';
// export const SET_BOOKING_ARTISTS_STATUS_DATASTATE = 'SET_BOOKING_ARTISTS_STATUS_DATASTATE';
// export const INSERT_BOOKING_ARTISTS_STATUS = 'INSERT_BOOKING_ARTISTS_STATUS';
// export const UPDATE_BOOKING_ARTISTS_STATUS = 'UPDATE_BOOKING_ARTISTS_STATUS';
// export const DELETE_BOOKING_ARTISTS_STATUS = 'DELETE_BOOKING_ARTISTS_STATUS';


// // BOOKING_ARTIST_OFFER_NOTE Action Types

// export const GET_BOOKING_ARTIST_OFFER_NOTE = 'GET_BOOKING_ARTIST_OFFER_NOTE';
// export const FETCH_BOOKING_ARTIST_OFFER_NOTE = 'FETCH_BOOKING_ARTIST_OFFER_NOTE';
// export const SET_BOOKING_ARTIST_OFFER_NOTE = 'SET_BOOKING_ARTIST_OFFER_NOTE';
// export const SET_BOOKING_ARTIST_OFFER_NOTE_DATASTATE = 'SET_BOOKING_ARTIST_OFFER_NOTE_DATASTATE';
// export const INSERT_BOOKING_ARTIST_OFFER_NOTE = 'INSERT_BOOKING_ARTIST_OFFER_NOTE';
// export const UPDATE_BOOKING_ARTIST_OFFER_NOTE = 'UPDATE_BOOKING_ARTIST_OFFER_NOTE';
// export const DELETE_BOOKING_ARTIST_OFFER_NOTE = 'DELETE_BOOKING_ARTIST_OFFER_NOTE';



// // INVOICE_LINES Action Types

// export const GET_INVOICE_LINES = 'GET_INVOICE_LINES';
// export const FETCH_INVOICE_LINES = 'FETCH_INVOICE_LINES';
// export const SET_INVOICE_LINES = 'SET_INVOICE_LINES';
// export const SET_INVOICE_LINES_DATASTATE = 'SET_INVOICE_LINES_DATASTATE';
// export const INSERT_INVOICE_LINES = 'INSERT_INVOICE_LINES';
// export const UPDATE_INVOICE_LINES = 'UPDATE_INVOICE_LINES';
// export const UPDATE_INVOICE_LINES_PRICE = 'UPDATE_INVOICE_LINES_PRICE';
// export const UPDATE_INVOICE_LINES_PRICE_TEXT = 'UPDATE_INVOICE_LINES_PRICE_TEXT';
// export const DELETE_INVOICE_LINES = 'DELETE_INVOICE_LINES';




// // INVOICE_TEXT Action Types

// export const GET_INVOICE_TEXT = 'GET_INVOICE_TEXT';
// export const FETCH_INVOICE_TEXT = 'FETCH_INVOICE_TEXT';
// export const SET_INVOICE_TEXT = 'SET_INVOICE_TEXT';
// export const SET_INVOICE_TEXT_DATASTATE = 'SET_INVOICE_TEXT_DATASTATE';
// export const INSERT_INVOICE_TEXT = 'INSERT_INVOICE_TEXT';
// export const UPDATE_INVOICE_TEXT = 'UPDATE_INVOICE_TEXT';
// export const DELETE_INVOICE_TEXT = 'DELETE_INVOICE_TEXT';



// export const SET_SELECTED_BOOKING_CANCELLATION_TOKEN = 'SET_SELECTED_BOOKING_CANCELLATION_TOKEN';
// export const GET_SELECTED_BOOKING_CANCELLATION_TOKEN = 'GET_SELECTED_BOOKING_CANCELLATION_TOKEN';



// export const FETCH_BOOKING_MODULE_INFO = 'FETCH_BOOKING_MODULE_INFO';
// export const GET_BOOKING_MODULE_INFO = 'GET_BOOKING_MODULE_INFO';
// export const SET_BOOKING_MODULE_INFO = 'SET_BOOKING_MODULE_INFO';

// export const SET_SELECTED_MONTHS = 'SET_SELECTED_MONTHS';

// // CONTACT_RELATION Action Types

// export const GET_CONTACT_RELATION = 'GET_CONTACT_RELATION';
// export const FETCH_CONTACT_RELATION = 'FETCH_CONTACT_RELATION';
// export const SET_CONTACT_RELATION = 'SET_CONTACT_RELATION';
// export const INSERT_CONTACT_RELATION = 'INSERT_CONTACT_RELATION';
// export const UPDATE_CONTACT_RELATION = 'UPDATE_CONTACT_RELATION';
// export const DELETE_CONTACT_RELATION = 'DELETE_CONTACT_RELATION';



// // CONTACT Action Types

// export const GET_CONTACT = 'GET_CONTACT';
// export const GET_MANY_CONTACTS = 'GET_MANY_CONTACTS';
// export const FETCH_CONTACT = 'FETCH_CONTACT';
// export const FETCH_MANY_CONTACTS = 'FETCH_MANY_CONTACTS';
// export const SET_CONTACT = 'SET_CONTACT';
// export const SET_MANY_CONTACTS = 'SET_MANY_CONTACTS';
// export const INSERT_CONTACT = 'INSERT_CONTACT';
// export const INSERT_MANY_CONTACTS = 'INSERT_MANY_CONTACTS';
// export const UPDATE_CONTACT = 'UPDATE_CONTACT';
// export const UPDATE_MANY_CONTACTS = 'UPDATE_MANY_CONTACTS';
// export const DELETE_CONTACT = 'DELETE_CONTACT';
// export const DELETE_MANY_CONTACTS = 'DELETE_MANY_CONTACTS';



// // SEND_DOCUMENT_FILES_DATA Action Types

// export const GET_SEND_DOCUMENT_FILES_DATA = 'GET_SEND_DOCUMENT_FILES_DATA';
// export const FETCH_SEND_DOCUMENT_FILES_DATA = 'FETCH_SEND_DOCUMENT_FILES_DATA';
// export const SET_SEND_DOCUMENT_FILES_DATA = 'SET_SEND_DOCUMENT_FILES_DATA';
// export const INSERT_SEND_DOCUMENT_FILES_DATA = 'INSERT_SEND_DOCUMENT_FILES_DATA';
// export const UPDATE_SEND_DOCUMENT_FILES_DATA = 'UPDATE_SEND_DOCUMENT_FILES_DATA';
// export const DELETE_SEND_DOCUMENT_FILES_DATA = 'DELETE_SEND_DOCUMENT_FILES_DATA';




// // ITEM_GROUP Action Types

// export const GET_ITEM_GROUP = 'GET_ITEM_GROUP';
// export const FETCH_ITEM_GROUP = 'FETCH_ITEM_GROUP';
// export const SET_ITEM_GROUP = 'SET_ITEM_GROUP';
// export const INSERT_ITEM_GROUP = 'INSERT_ITEM_GROUP';
// export const UPDATE_ITEM_GROUP = 'UPDATE_ITEM_GROUP';
// export const DELETE_ITEM_GROUP = 'DELETE_ITEM_GROUP';


// export const ENABLE_ONLINE_AGREEMENT = 'ENABLE_ONLINE_AGREEMENT';
// export const GENERATE_DISPLAY_ONLY_DOC = 'GENERATE_DISPLAY_ONLY_DOC';
// export const GENERATE_SIGNED_DOCUMENT = 'GENERATE_SIGNED_DOCUMENT';

// export const SEND_MAIL_ON_SIGNING_CONTRACT = 'SEND_MAIL_ON_SIGNING_CONTRACT';



// export const SET_BOOKING_TAB = 'SET_BOOKING_TAB';

// export const TASKS = createActionTypeModel('TASKS');
// export const COMPLETE_TASK = 'COMPLETE_TASK';
// export const UNDO_TASK = 'UNDO_TASK';

// export const MAXIMIZE_INVOICE_GROUP = 'MAXIMIZE_INVOICE_GROUP';
// export const MINIMIZE_INVOICE_GROUP = 'MINIMIZE_INVOICE_GROUP';


// // TAX_TYPES Action Types

// export const GET_TAX_TYPES = 'GET_TAX_TYPES';
// export const FETCH_TAX_TYPES = 'FETCH_TAX_TYPES';
// export const SET_TAX_TYPES = 'SET_TAX_TYPES';
// export const INSERT_TAX_TYPES = 'INSERT_TAX_TYPES';
// export const UPDATE_TAX_TYPES = 'UPDATE_TAX_TYPES';
// export const DELETE_TAX_TYPES = 'DELETE_TAX_TYPES';


// export const SET_SELECTED_INVOICE_LINE = 'SET_SELECTED_INVOICE_LINE';

// export const GET_LOGGED_USER_TASKS = 'GET_LOGGED_USER_TASKS';
// export const SET_LOGGED_USER_TASKS = 'SET_LOGGED_USER_TASKS';
// export const GET_BOOKING_REQUESTS = 'GET_BOOKING_REQUESTS';
// export const SET_BOOKING_REQUESTS = 'SET_BOOKING_REQUESTS';
// export const DELETE_BOOKING_REQUEST = 'DELETE_BOOKING_REQUEST';

// export const GET_BOOKING_TEMPLATES = 'GET_BOOKING_TEMPLATES';
// export const SET_BOOKING_TEMPLATES = 'SET_BOOKING_TEMPLATES';
// export const DELETE_BOOKING_TEMPLATE = 'DELETE_BOOKING_TEMPLATE';
// export const ADD_BOOKING_TEMPLATE = 'ADD_BOOKING_TEMPLATE';

// // FILTER Action Types

// export const GET_FILTER = 'GET_FILTER';
// export const FETCH_FILTER = 'FETCH_FILTER';
// export const SET_FILTER = 'SET_FILTER';
// export const RESET_FILTER = 'RESET_FILTER';
// export const INSERT_FILTER = 'INSERT_FILTER';
// export const UPDATE_FILTER = 'UPDATE_FILTER';
// export const DELETE_FILTER = 'DELETE_FILTER';


// export const BOOKING_LIST_FILTER = 'BOOKING_LIST_FILTER';



// // EXTERNAL_CALENDAR_DATES Action Types

// export const GET_EXTERNAL_CALENDAR_DATES = 'GET_EXTERNAL_CALENDAR_DATES';
// export const FETCH_EXTERNAL_CALENDAR_DATES = 'FETCH_EXTERNAL_CALENDAR_DATES';
// export const SET_EXTERNAL_CALENDAR_DATES = 'SET_EXTERNAL_CALENDAR_DATES';
// export const INSERT_EXTERNAL_CALENDAR_DATES = 'INSERT_EXTERNAL_CALENDAR_DATES';
// export const UPDATE_EXTERNAL_CALENDAR_DATES = 'UPDATE_EXTERNAL_CALENDAR_DATES';
// export const DELETE_EXTERNAL_CALENDAR_DATES = 'DELETE_EXTERNAL_CALENDAR_DATES';


// export const SET_USERS = 'SET_USERS';